import React from "react";
import { RequestNowModalProps } from "./types";
import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import { FlatList, Pressable, View } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { Container, VDBText } from "@components/atoms";
import VDBIcon, { IconsType, IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useHeaderBulkOption } from "../../hooks/useHeaderBulkOption";

const RequestBMHModal = ({
  isOpen,
  onClose,
  productType,
  priceMode,
  selectOption,
  requestItems: requestItemsProp,
}: RequestNowModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const toTestId = (value: string) => value.replace(/\s+/g, "-").toLowerCase();

  const { requestItems: requestItemsFromHook } = useHeaderBulkOption(
    productType,
    priceMode,
    t
  );
  const requestItems = requestItemsProp ?? requestItemsFromHook;

  const ItemCard = ({ item }: any) => {
    const itemKey = toTestId(String(item?.name ?? "unknown"));
    return (
      <Pressable
        onPress={() => selectOption(item.name)}
        testID={`bmh.request.option.${itemKey}`}
        data-testId={`bmh.request.option.${itemKey}`}
      >
        <Container>
          <ParentContainer theme={theme}>
            <OverLay>
              <CardMain>
                <View style={{ marginRight: 10 }}>
                  <VDBIcon
                    name={item.left_icon.data}
                    uri={item.left_icon.data}
                    size={30}
                    color={theme["core-06"]}
                    variant={
                      item.type === IconsType.img_url
                        ? IconsVariant.CustomUrl
                        : IconsVariant.VDBCustom
                    }
                  />
                </View>
                <VDBText color={theme["core-05"]} type={typography["H3-M"]}>
                  {item.label}
                </VDBText>
              </CardMain>

              <View>
                <VDBIcon
                  name={VDBIcons.ARROW_RIGHT}
                  size={24}
                  color={theme["core-04"]}
                  variant={IconsVariant.VDBCustom}
                />
              </View>
            </OverLay>
          </ParentContainer>
        </Container>
      </Pressable>
    );
  };

  return (
    <Modal
      headerTitle={t("searchResult.modal.bmh.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={1}
      paddingRight={1}
      paddingBottom={40}
      paddingTop={1}
      backgroundColor={theme?.["core-02"]}
      skipKeyboardAware={theme.isLargeScreen ? true : false}
    >
      <FlatList
        data={requestItems}
        renderItem={({ item }) => <ItemCard item={item} />}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          backgroundColor: theme["core-02"],
        }}
      />
    </Modal>
  );
};

const ParentContainer = styled.View<any>`
  width: auto;
  flex-direction: column;
  border-bottom-width: 1px;
  border-color: ${({ theme }) => theme["core-03"]};
`;

const OverLay = styled.View<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => (noPadding ? 0 : 16)}px;
  flex-direction: column;
  width: 100%;
  flex-direction: row;
`;

const CardMain = styled.View`
  flex-direction: row;
  align-items: center;
  align-content: flex-start;
  flex: 1;
`;

export default RequestBMHModal;
